import React from 'react';
import { Link } from 'react-router-dom';
import linkedinLogo from '../assets/LI-In-Bug.png';
import './Footer.css';

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-left">
          © {new Date().getFullYear()} NHHS Analytics
        </div>
        <div className="footer-links">
          <a href="/contact" className="footer-link">Contact</a>
          <a href="/admin" className="footer-link">Admin</a>
          <Link to="/privacy-policy" className="footer-link">Privacy Policy</Link>
        </div>
        <div className="footer-socials">
          <a
            href="https://www.linkedin.com/company/quant-club-nhhs-analytics/posts/?feedView=all"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="LinkedIn"
            className="footer-linkedin"
          >
            <img
              src={linkedinLogo}
              alt="LinkedIn"
              width={24}
              height={24}
              className="footer-linkedin-logo"
            />
          </a>
        </div>
      </div>
    </footer>
  );
}